export default __webpack_public_path__ + "static/media/product-page-included.f3f1c493.png";